module.exports = __webpack_public_path__ + "static/recoleta-medium-webfont-518606f181085eb1ff6950e1eaa0dd3d.woff2";